import { getField, updateField } from 'vuex-map-fields';
import Http from "@/shared/http-config";

export default {
  namespaced: true,

  state () {
    return {
      meta: {
        current_page: 1,
        total: 1,
        per_page: 10,
      },
      filter: {
        category_id: 0,
      },
      categories: []
    }
  },

  actions: {
    async fetchCategories(context, force = false){
      if(context.state.categories.length === 0 || force) {
        let categories_list = [];
        let categories_response = await Http.request('get', '/courses/categories');
        categories_response.data.forEach((category) => {
          categories_list.push({
            text: category.name,
            value: category.id
          });
        });
        context.commit('set', ['categories', categories_list]);
      }
      return await new Promise((resolve) => {
        resolve(context.state.categories);
      });
    },
  },

  mutations: {
    set(state, [key, value]) {
      state[key] = value;
    },
    updateField,
  },

  getters: {
    get: (state) => (variable) => {
      return state[variable];
    },
    getField,
  }
};
